import { z } from 'zod';
import { PublicProfileDto } from './networking';

/**
 * Заявитель в деталке RSVP: публичный профиль + поля только этого эндпоинта (не deck).
 * `energyAvailable` наследуется из `PublicProfileDto` опциональным — сервер кладёт
 * его только admin-viewer'у, обычный организатор чужой баланс не видит.
 */
export const OrganizerRsvpAttendeeDto = PublicProfileDto.extend({
  telegramUsername: z.string().nullable(),
  registeredAt: z.iso.datetime(),
});
export type OrganizerRsvpAttendeeDto = z.infer<typeof OrganizerRsvpAttendeeDto>;

export const PendingRsvpRequestDto = z.object({
  attendanceId: z.uuid(),
  eventId: z.uuid(),
  eventTitle: z.string(),
  attendee: PublicProfileDto,
  createdAt: z.iso.datetime(),
});
export type PendingRsvpRequestDto = z.infer<typeof PendingRsvpRequestDto>;

export const PendingRsvpRequestsResponse = z.object({
  items: z.array(PendingRsvpRequestDto),
});
export type PendingRsvpRequestsResponse = z.infer<typeof PendingRsvpRequestsResponse>;

export const OrganizerRsvpRequestDetailDto = z.object({
  attendanceId: z.uuid(),
  eventId: z.uuid(),
  eventTitle: z.string(),
  eventDescription: z.string().nullable(),
  eventStartsAt: z.iso.datetime(),
  eventEndsAt: z.iso.datetime().nullable(),
  eventHasStartTime: z.boolean(),
  eventVenueText: z.string().nullable(),
  eventCoverImageUrl: z.string().nullable(),
  eventPlaceName: z.string().nullable(),
  attendee: OrganizerRsvpAttendeeDto,
});
export type OrganizerRsvpRequestDetailDto = z.infer<typeof OrganizerRsvpRequestDetailDto>;

export const RejectRsvpInput = z.object({
  reason: z.string().min(1).max(2000),
});
export type RejectRsvpInput = z.infer<typeof RejectRsvpInput>;
